import { useStore } from "../store";
import { getMediaProperty } from "../utils";
import { setUpdatedValues } from "../store/actions";
import { toast } from "react-toastify";

export function useConnectsUForm() {
  const { dispatch, updatedValues } = useStore();
  const updateImage = (event, i, form, tabKey) => {
    if (event.target.files && event.target.files[0].size >= 2e6) {
      toast.error("File should not exceed 2MB");
    } else {
      const fields = form.getFieldValue(tabKey);
      if (fields && fields.length > 0) {
        const media = getMediaProperty(event);
        const modifiedData = fields.map((d, indx) => {
          if (indx === i) {
            d.mediaLink = { ...d?.mediaLink, ...media?.mediaProperty };
            d.blob = media?.blob;
          }
          return d;
        });

        form.resetFields();
        form.setFieldsValue({
          [tabKey]: modifiedData,
        });
        var prev = updatedValues;

        const prevItems = prev[tabKey];
        if (prevItems) {
          const names = [...prevItems, i];
          const removeDuplicates = names.filter(function (
            item,
            index,
            inputArray
          ) {
            return inputArray.indexOf(item) == index;
          });
          prev[tabKey] = removeDuplicates;
        } else {
          prev[tabKey] = [i];
        }
        dispatch(setUpdatedValues(prev))
      }
    }
  };

  const rerenderForm = (form) => {
    const fields = form.getFieldsValue(true);
    form.resetFields();
    form.setFieldsValue(fields);
  };
  return {
    updateImage,
    rerenderForm,
  };
}
